import { Link } from "react-router-dom";
import logo from "../../assets/image/logoSmall.png";
import appConfig from "../../config/appConfig.json";

const Header = () => {
  const menuClose = () => {
    const mobileMenu = document.getElementById("w-nav-overlay-0");
    mobileMenu.style.display = "none";
  };

  return (
    <div
      data-collapse="small"
      data-animation="default"
      data-duration={400}
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="nav-bar w-nav">
      <div className="nav-container w-container">
        <div className="logo-div">
          <Link
            to="/"
            aria-current="page"
            className="nav-logo w-inline-block w--current">
            <img
              src={logo}
              width={142}
              alt="SAHABT Teams NFTs"
              className="logo"
            />
          </Link>
        </div>
        <nav role="navigation" className="nav-content w-nav-menu">
          <div className="nav-menu">
            <Link
              to="/#About"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              Hakkımızda
            </Link>
            <Link
              to="/#Roadmap"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              Yol Haritası
            </Link>
            <Link
              to="/#Attributes"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              Benzersizlik
            </Link>
            <Link
              to="/#Creator"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              Yaratılış Hikayesi
            </Link>
            <Link
              to="gallery"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              Galeri
            </Link>
            <Link
              to="contact"
              className="nav-link w-nav-link"
              onClick={() => menuClose()}>
              İletişim
            </Link>
          </div>
          {/* <div className="social-links">
            <a
              href="http://www.twitter.com"
              className="social-link-block w-inline-block"
              target="_blank"
              rel="noreferrer">
              <img
                src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab3a32fc6b256c7902084b_Twitter%20-%20Negative.svg"
                loading="lazy"
                width={33}
                alt="Twitter Icon"
                className="social-icon"
              />
            </a>
            <a
              href="http://www.discord.com"
              className="social-link-block w-inline-block"
              target="_blank"
              rel="noreferrer">
              <img
                src="https://assets.website-files.com/619f485207368e1139a39a1c/61ab3a32b8be1230b2fdcf89_Discord%20-%20Negative.svg"
                loading="lazy"
                width={33}
                alt="Discord Icon"
                className="social-icon"
              />
            </a>
          </div> */}
          <div className="nav-cta-button-container">
            <a
              href={appConfig.openSea}
              className="nav-link primary w-nav-link"
              target="_blank"
              rel="noreferrer">
              OpenSea'de Görüntüle
            </a>
          </div>
        </nav>
        <div className="menu-button w-nav-button">
          <img
            src="https://assets.website-files.com/619f485207368e1139a39a1c/61ac549bd46f305b8f4f3212_Black%20Mobile%20Menu.svg"
            loading="lazy"
            width={24}
            alt=""
            className="menu-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
